<template>
   <app-parser_wrapper  :init="init">    </app-parser_wrapper>
</template>

<script>
 export default {

     data () {
       return {
   init: {
     menu:{
       items: [
         {
           title:"Посты сообществ",
           objName: 'groups',
           dataType:"posts",
           form: [
             {
               type:'info',
               vModel: {contentType:'groups',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список сообществ',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active:false,
                 },
                 procUpdatesLabel: "Обновления процессов как список сообществ",
                 contentType: 'groups',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.groups,
               label: 'Использовать запомненные сообщества: '+ this.$store.state.memory.groups ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'groups',
               dataType: 'memory',
             },
           {
             type:'textarea',
             name: 'Список сообществ',
             vModel: {name:'itemsList',value:''},
             vkapi: false,
             dataType: 'list'
           },
           {
             type:'select',
             name: 'Фильтр по автору',
             options: [{text:'Все записи',value:'all'},{text:'Записи сообщества',value:'owner'},{text:'Записи других авторов',value:'others'}],
             vModel: {name:'filter',value:'all'},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type:'select',
             name: 'Фильтр по времени (не более чем)',
             options: [
                 {text:'Все записи',value:'all'},
                 {text:'5 минут назад',value:'300'},
                 {text:'10 минут назад',value:'600'},
                 {text:'30 минут назад',value:'1800'},
                 {text:'1 час назад',value:'3600'},
                 {text:'3 часа назад',value:'10800'},
                 {text:'5 часов назад',value:'18000'},
                 {text:'10 часов назад',value:'36000'},
                 {text:'сутки назад',value:'86400'},
                 {text:'3 суток назад',value:'259200'},
                 {text:'5 суток назад',value:'432000'},
                 {text:'10 суток назад',value:'864000'},
                 {text:'месяц назад',value:'2629746'},
                 {text:'2 месяца назад',value:'5259492'},
                 {text:'пол года назад',value:'15778476'},
                 {text:'год назад',value:'31622400'},
                 {text:'3 года назад',value:'94867200'},
                 {text:'5 лет назад',value:'158112000'},
                 {text:'10 лет назад',value:'316224000'},
             ],
             vModel: {name:'filterByTime',value:'all'},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'input',
             name: 'Пропустить первые',
             vModel: {name:'offset',value:'0'},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'input',
             name: 'Постов с сообщества',
             vModel: {name:'post_count',value:'50'},
             vkapi: false,
             dataType: 'FormParams'
           },
           ],

       },

         {
           title:"Посты страниц",
           objName: 'pages',
           dataType:"posts",
           form: [
             {
               type:'info',
               vModel: {contentType:'pages',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список страниц',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список страниц",
                 contentType: 'pages',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.pages,
               label: 'Использовать запомненные страницы: '+ this.$store.state.memory.pages ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'pages',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список страниц',
               vModel: {name:'itemsList',value:''},
               vkapi: false,
               dataType: 'list'
             },

             {
               type:'select',
               name: 'Фильтр',
               options: [{text:'Все записи',value:'all'},{text:'Записи страницы',value:'owner'},{text:'Записи других авторов',value:'others'}],
               vModel: {name:'filter',value:'all'},
               vkapi: true
             },
             {
               type:'select',
               name: 'Фильтр по времени (не более чем)',
               options: [
                   {text:'Все записи',value:'all'},
                   {text:'5 минут назад',value:'300'},
                   {text:'10 минут назад',value:'600'},
                   {text:'30 минут назад',value:'1800'},
                   {text:'1 час назад',value:'3600'},
                   {text:'3 часа назад',value:'10800'},
                   {text:'5 часов назад',value:'18000'},
                   {text:'10 часов назад',value:'36000'},
                   {text:'сутки назад',value:'86400'},
                   {text:'3 суток назад',value:'259200'},
                   {text:'5 суток назад',value:'432000'},
                   {text:'10 суток назад',value:'864000'},
                   {text:'месяц назад',value:'2629746'},
                   {text:'2 месяца назад',value:'5259492'},
                   {text:'пол года назад',value:'15778476'},
                   {text:'год назад',value:'31622400'},
                   {text:'3 года назад',value:'94867200'},
                   {text:'5 лет назад',value:'158112000'},
                   {text:'10 лет назад',value:'316224000'},
               ],
               vModel: {name:'filterByTime',value:'all'},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Пропустить первые',
               vModel: {name:'offset',value:'0'},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Постов со страницы',
               vModel: {name:'post_count',value:'50'},
               vkapi: false,
               dataType: 'FormParams'
             },
           ]
         },





       ],

     },
    title:{
      first: 'Постов найденно:'
    },

    searchLoop:{
      active:false,
      placeholder:'Введите имя через запятую'
    },

    beforeSearch:{
      title: 'Тут будет отображен результат парсера постов',
      activator: true,
      activatorName: 'Начать парсинг'
    },


    network:{
      processName: 'posts_pars',
      dataType: 'posts',
      actionsFile:  'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/searcher/posts_pars.php'
    },




objName: 'groups',   // поиск в сообществах, так как изначально форма от поиска в сообществах

    contentMenegment: {
      marginTop: '0px',
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'posts',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
      }
     },
     progressСircular: false,
   }


       }
     },

     created(){

   this.init.forma = this.init.firstForma

     },
   }
</script>


<style>

</style>
